import React from 'react';

const Logo = ({ className = "" }) => {
  return (
    <div className={`flex items-center gap-3 ${className}`}>
      <div className="relative">
        <svg
          width="40"
          height="40"
          viewBox="0 0 40 40"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M20 5C11.716 5 5 11.716 5 20C5 28.284 11.716 35 20 35C28.284 35 35 28.284 35 20"
            stroke="#CCFF00"
            strokeWidth="2.5"
            strokeLinecap="round"
          />
          <path
            d="M35 20L31 16M35 20L31 24"
            stroke="#CCFF00"
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M20 12C20 12 15 15 15 20C15 23 17 25 20 25C23 25 25 23 25 20C25 15 20 12 20 12Z"
            fill="#CCFF00"
          />
          <path
            d="M20 12L20 25"
            stroke="#050505"
            strokeWidth="1.5"
            strokeLinecap="round"
          />
        </svg>
      </div>
      <div className="flex flex-col leading-tight">
        <span className="text-xl font-heading font-bold tracking-tight text-primary">MeJ</span>
        <span className="text-xs text-zinc-400 uppercase tracking-wider">Crédito de Carbono</span>
      </div>
    </div>
  );
};

export default Logo;
